export const sizes = {
  default: 16,
  small: 14,
  large: 18,
  mini: 12
};

export const handlePaperLines = ({ text, board, fontSize }: { text: string, board: any, fontSize: 'small' | 'default' | 'large' }) => {
  const stringEssayArray = text ? text.split('\n') : [];
  const size = sizes[fontSize];
  const lineMaxChars = board.font[size].lineMaxChars;

  const essayTextArray = stringEssayArray
    .map((item) => {
      let currentSubstring = '';
      const subStrings: string[] = [];
      const words = item.split(' ');

      for (let i = 0; i < words.length; i++) {
        const word = words[i];
        const enoughSpace = currentSubstring.length + word.length + 1 <= lineMaxChars;
        const justEnough = currentSubstring.length + word.length <= lineMaxChars;

        if (enoughSpace || justEnough) {
          if (enoughSpace) {
            currentSubstring += word + ' ';
          } else {
            currentSubstring += word;
          }
        } else {
          subStrings.push(currentSubstring.trim());
          currentSubstring = word + ' ';
        }
      }

      subStrings.push(currentSubstring.trim());

      return subStrings;
    }).flat();

  return essayTextArray.length === 30 ? essayTextArray.length - 1 : essayTextArray.length;
};